export default __webpack_public_path__ + "static/media/intro_background.f2f0a713.png";